import { countriesWithRegions } from '@/constants/billingAddress';
import { AddressInput } from '@/graphql/types-and-hooks';

export const acceptedCountryCodes = [
  'AT',
  'AU',
  'BE',
  'BR',
  'BG',
  'CA',
  'CN',
  'CZ',
  'DE',
  'DK',
  'FI',
  'FR',
  'GB',
  'GR',
  'HU',
  'IE',
  'IT',
  'JP',
  'KR',
  'MX',
  'MY',
  'NL',
  'NO',
  'NZ',
  'PL',
  'PT',
  'HR',
  'RS',
  'SI',
  'RO',
  'RU',
  'ES',
  'SE',
  'CH',
  'TR',
  'US',
];

type TAddressField =
  | 'thoroughfare'
  | 'primise'
  | 'localityName'
  | 'administrativeArea'
  | 'postalCode';

const keyMap = {
  thoroughfare: 'street1',
  primise: 'street2',
  localityName: 'city',
  dependentLocalityName: '',
  administrativeArea: 'state',
  postalCode: 'zip',
};

type TAddressFieldByCountry = Record<
  string,
  {
    [key: string]: any;
  }
>;
const addressFieldsByCountry: TAddressFieldByCountry = {
  default: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    postalCode: {
      sort: 4,
      variant: 'postal-code',
    },
  },
  AT: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  AU: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    administrativeArea: {
      sort: 3,
      type: 'select',
      variant: 'state',
    },
    postalCode: {
      sort: 4,
      variant: 'postal-code',
    },
  },
  BE: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  BR: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    dependentLocalityName: {
      sort: 2,
    },
    localityName: {
      sort: 3,
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'state',
    },
    postalCode: {
      sort: 5,
      variant: 'postal-code',
    },
  },
  BG: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  CA: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    administrativeArea: {
      sort: 3,
      type: 'select',
      variant: 'province',
    },
    postalCode: {
      sort: 4,
      variant: 'postal-code',
    },
  },
  CN: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    dependentLocalityName: {
      sort: 2,
    },
    localityName: {
      sort: 3,
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'province',
    },
    postalCode: {
      sort: 5,
      variant: 'postal-code',
    },
  },
  CZ: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  DE: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    postalCode: {
      sort: 3,
      variant: 'postal-code',
    },
  },
  DK: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  FI: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  FR: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    postalCode: {
      sort: 3,
      variant: 'postal-code',
    },
  },
  GB: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    postalCode: {
      sort: 4,
      variant: 'postal-code',
    },
  },
  GR: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  HU: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  IE: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    administrativeArea: {
      sort: 3,
      type: 'text',
      variant: 'province',
    },
    postalCode: {
      sort: 4,
      variant: 'postal-code',
    },
  },
  IT: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    postalCode: {
      sort: 3,
      variant: 'postal-code',
    },
  },
  JP: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'prefecture',
    },
  },
  KR: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    dependentLocalityName: {
      sort: 2,
    },
    localityName: {
      sort: 3,
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'province',
    },
    postalCode: {
      sort: 5,
      variant: 'postal-code',
    },
  },
  MX: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    dependentLocalityName: {
      sort: 2,
    },
    localityName: {
      sort: 3,
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'state',
    },
    postalCode: {
      sort: 5,
      variant: 'postal-code',
    },
  },
  MY: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    dependentLocalityName: {
      sort: 2,
    },
    localityName: {
      sort: 3,
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'state',
    },
    postalCode: {
      sort: 5,
      variant: 'postal-code',
    },
  },
  NL: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  NO: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  NZ: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    postalCode: {
      sort: 3,
      variant: 'postal-code',
    },
  },
  PL: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  PT: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  HR: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  RS: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  SI: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  RO: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  RU: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    administrativeArea: {
      sort: 3,
      type: 'select',
      variant: 'province',
    },
    postalCode: {
      sort: 4,
      variant: 'postal-code',
    },
  },
  ES: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  SE: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  CH: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 2,
      variant: 'postal-code',
    },
    localityName: {
      sort: 3,
    },
  },
  TR: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    postalCode: {
      sort: 3,
      variant: 'postal-code',
    },
    administrativeArea: {
      sort: 4,
      type: 'select',
      variant: 'province',
    },
    localityName: {
      sort: 5,
    },
  },
  US: {
    thoroughfare: {
      sort: 0,
    },
    primise: {
      sort: 1,
    },
    localityName: {
      sort: 2,
    },
    administrativeArea: {
      sort: 3,
      type: 'select',
      variant: 'state',
    },
    postalCode: {
      sort: 4,
      variant: 'zip',
    },
  },
};

function getSortedFieldsForCountry(country: string) {
  const countryFields = addressFieldsByCountry[country];
  // @ts-expect-error fixable: unchecked index access
  return Object.keys(countryFields).sort((a, b) => countryFields[a].sort - countryFields[b].sort);
}

export const formatAddress = ({
  address,
  showCountry,
}: {
  address: { [key: string]: string };
  showCountry?: boolean;
}) => {
  let formattedAddress = '';
  const order = getSortedFieldsForCountry(address.countryCode || 'default') as TAddressField[];
  order.forEach(key => {
    const field = keyMap[key];
    if (!showCountry && field === 'country') {
      return;
    }
    if (keyMap[key] === 'street2' && (address.street1 || address.street2)) {
      formattedAddress += ' \n';
    }
    if (address[field]) {
      formattedAddress += `${address[field]} `;
    }
  });
  return formattedAddress;
};

/** return list of invalid fields */
export const validateAddress = (address: AddressInput): (keyof AddressInput)[] => {
  const errors: (keyof AddressInput)[] = [];
  if (!address.city) {
    errors.push('city');
  }
  if (!address.country) {
    errors.push('country');
  }
  if (
    countriesWithRegions.includes(address.country as (typeof countriesWithRegions)[number]) &&
    !address.state
  ) {
    errors.push('state');
  }
  if (!address.street) {
    errors.push('street');
  }
  if (!address.zip) {
    errors.push('zip');
  }

  return errors;
};
